'use client'

import Loading from "@/components/layout/page-loader"


export default function Page() {
    return <Loading />
};
